import { configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import { mapReducer } from '@alltrails/maps/redux/reducer';
import conditionsMiddleware from './conditionsMiddleware';
import ConditionsRootState from './ConditionsRootState';
import { conditionsReducer } from './conditionsSlice';

type PreloadedState = Partial<ConditionsRootState>;

const reducer = { conditions: conditionsReducer, context, map: mapReducer };

export const getConfigureStoreOptions = (preloadedState?: PreloadedState) => ({
  reducer,
  preloadedState,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(conditionsMiddleware)
});

// eslint-disable-next-line unused-imports/no-unused-vars
const buildStore = (preloadedState?: PreloadedState) => configureStore(getConfigureStoreOptions(preloadedState));

type AppStore = ReturnType<typeof buildStore>;
type AppDispatch = AppStore['dispatch'];

// these are intended to be used within the package only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<ConditionsRootState> = (selector: (state: ConditionsRootState) => any) =>
  useSelector<ConditionsRootState, any>(selector, shallowEqual);
